import React from "react"

import "./ListOfSales"

import Sidebar from "../../Components/Sidebar/Sidebar"
import LabelHeader from "../../Components/Commons/LabelHeader"
import TextField from "../../Components/Commons/Forms/TextField"
import BtnSave from "../../Components/Commons/Buttons/BtnSave"
import TextArea from "../../Components/Commons/Forms/TextArea"
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete"

import { useNavigate, useParams } from "react-router-dom"

function AddEditInventories() {
  const id = useParams()
  const navigate = useNavigate()

  return (
    <div className="App">
      <Sidebar active={"Patients"} />
      <div className=" add-customer col p-5 pt-4">
        <LabelHeader
          text={` ${id.id ? "Edit Inventory" : "Add Item to Inventory"}`}
        />
        <hr />
        <div className="row">
          <div className="col-8">
            <TextField
              required
              id="contact_no"
              name="contact_no"
              formLabel={`Item`}
              size={`sm`}
              errorMessage="This is an error"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-8">
            <TextArea
              required
              id="contact_no"
              name="contact_no"
              formLabel={`Description`}
              size={`sm`}
              errorMessage="This is an error"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <TextField
              required
              id="contact_no"
              name="contact_no"
              formLabel={`Unit Price`}
              size={`sm`}
              errorMessage="This is an error"
            />
          </div>
          <div className="col-4">
            <TextField
              required
              id="contact_no"
              name="contact_no"
              formLabel={`Stock`}
              size={`sm`}
              errorMessage="This is an error"
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-3">
            <BtnSave label={"Save Item to Inventory"} size={"md"} />
          </div>
          <div className="col-3">
            <BtnDelete
              label={"Cancel"}
              size={"md"}
              onClick={() => navigate("/inventories")}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddEditInventories
